import { NgModule } from '@angular/core';
import { EnvTypeRotateItemComponent} from './rotatorItem'
import {EnvironmentsRotatorModule} from './environmentsRotator/environmentsRotator.module'
import {rotateSchemasRepositoryModule} from './rotate-schemas-repository/rotate-schemas-repository.module'
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common'

@NgModule({
    imports: [ FormsModule,EnvironmentsRotatorModule,rotateSchemasRepositoryModule,CommonModule],
    declarations: [
        // EnvironmentItemComponent,
        EnvTypeRotateItemComponent
    ],
    entryComponents: [
        EnvTypeRotateItemComponent
    ],
    exports: [
        EnvTypeRotateItemComponent
    ]
})
export class RotatorItemModule {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/assignSchemas-ang7/environmentTypeRotator/rotatorItem/rotatorItem.module.ts